/* eslint no-param-reassign: "off" */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Grade from '../../types/Grade';

interface State {
  ids: number[];
  values: Record<number, Grade>;
}

const initialState: State = {
  ids: [],
  values: {},
};

const gradesSlice = createSlice({
  name: 'grades',
  initialState,
  reducers: {
    setAllGrades: (state, action: PayloadAction<Grade[]>) => {
      state.ids = [];
      state.values = {};

      action.payload.forEach((value) => {
        const { id } = value;
        state.ids.push(id);
        state.values[id] = value;
      });
    },
  },
});

export const selectGrades = (state: any): Record<number, Grade> =>
  state.grades.values;

export const { setAllGrades } = gradesSlice.actions;
export default gradesSlice.reducer;
